import { render } from "./ContactUs.vue?vue&type=template&id=1cab3e1f&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=1cab3e1f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cab3e1f"

export default script